<div *ngIf="isShowLoader" class="popOverlay">
<p-progressSpinner [style]="{width: '3.125rem', height: '3.125rem'}" styleClass="custom-spinner" strokeWidth="4"
    fill="var(--text-color-secondary)" animationDuration=".5s"></p-progressSpinner>  
</div>
